import { Configuration, LogLevel } from "@azure/msal-browser";
import { logger } from '../utils/logger';

// Hole Umgebungsvariablen (Vite verwendet das Präfix VITE_ für Client-Umgebungsvariablen)
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || "";
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "";

// Der Redirect URI ist die URL, zu der Azure AD den Benutzer nach der Authentifizierung zurückleitet
// Für die lokale Entwicklung ist das normalerweise http://localhost:3000
// In der Produktion sollte dies die URL deiner Anwendung sein
const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin;

// Überprüfe, ob die Umgebungsvariablen vorhanden sind
if (!clientId || !tenantId) {
  logger.warn("Azure AD Konfiguration fehlt! Stelle sicher, dass VITE_AZURE_CLIENT_ID und VITE_AZURE_TENANT_ID in deiner .env-Datei definiert sind.");
} else {
  logger.log("Azure AD Config:", {
    clientId: clientId,
    tenantId: tenantId,
    redirectUri: redirectUri,
    authority: `https://login.microsoftonline.com/${tenantId}`
  });
}

// Azure AD B2C Konfiguration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
    redirectUri: redirectUri,
    // Optional: Postlogout-Redirect-URI hinzufügen
    postLogoutRedirectUri: redirectUri,
    // Erweiterte Konfiguration für SPA
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logger.error(message);
            return;
          case LogLevel.Info:
            logger.info(message);
            return;
          case LogLevel.Verbose:
            logger.debug(message);
            return;
          case LogLevel.Warning:
            logger.warn(message);
            return;
        }
      },
    },
  },
};

// Berechtigungen/Scopes, die die Anwendung anfordert
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
  prompt: "select_account"
};

// Hier können bestimmte Rollen oder Benutzergruppen definiert werden
export const protectedResources = {
  archiveApi: {
    endpoint: "/api/archive",
    scopes: ["User.Read"],
  },
}; 